<section>
  <ion-header class="ion-no-border">
    <ion-toolbar>
      <ion-buttons slot="end">
        <ion-button (click)="dismiss()">
          <ion-icon name="close-circle-outline"></ion-icon>
        </ion-button>
      </ion-buttons>
      <ion-title>Importante</ion-title>
    </ion-toolbar>
  </ion-header>
  <hr>
</section>

<article>
  <ion-text>Com o modo Seleção automática habilitado, <br/>
    o MonitorAr atualizará a estação principal de acordo <br/>
    com a localização do usuário no raio de 10 (dez) km. <br/>
    Com essa opção desabilitada, a estação principal deverá ser<br/>
    selecionada pelo usuário manualmente.</ion-text>
</article>